import { FormField } from '@loomhq/lens';
import React from 'react';

import { isValidWorkspaceName } from 'utilities/workspace';

function WorkspaceNameFormField({ workspaceName, children }) {
  const invalidWorkspaceName = !isValidWorkspaceName(workspaceName);

  return (
    <FormField
      label="Name"
      labelFor="name"
      errorMessage={
        invalidWorkspaceName &&
        'Workspace names cannot contain the following: ., :, @, /, \\'
      }
    >
      {children}
    </FormField>
  );
}

export default WorkspaceNameFormField;
